"use client";

import React from "react";

import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@/components/flowbite/dropdown";
import { ListOption } from "@/components/flowbite/list-option/list-option";
import { MoreVertIcon } from "@/components/icons-lib";
import { cn } from "@/shared/helpers/cn.helper";

export interface ActionsMenuDropdownAction {
  label: string;
  onClick: () => void;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  className?: string;
}

interface ActionsMenuDropdownProps {
  actions: ActionsMenuDropdownAction[];
  footer?: React.ReactNode;
  triggerClassName?: string;
  ariaLabel?: string;
  disabled?: boolean;
}

export const ActionsMenuDropdown: React.FC<ActionsMenuDropdownProps> = ({
  actions,
  footer,
  triggerClassName,
  ariaLabel = "Actions menu",
  disabled = false,
}) => {
  if (actions.length === 0) return null;

  return (
    <Dropdown
      className="flex w-full items-center justify-center"
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
    >
      <DropdownButton
        aria-label={ariaLabel}
        className={cn(
          "inline-flex h-6 w-6 shrink-0 items-center justify-center rounded transition-colors duration-300",
          "[&_svg]:text-btn-icon",
          triggerClassName,
        )}
        disabled={disabled}
        onClick={(e: React.MouseEvent) => e.stopPropagation()}
      >
        <MoreVertIcon className="h-6 w-6" />
      </DropdownButton>
      <DropdownItems className="right-0 top-full mt-1 p-1">
        {actions.map((action) => (
          <DropdownItem
            key={action.label}
            className="text-start text-sm"
            variant="unstyled"
          >
            {({ close }) => (
              <ListOption
                className={cn("w-full cursor-pointer rounded-lg transition-colors duration-300 hover:bg-gray-100", action.className)}
                icon={action.icon}
                label={action.label}
                size="small"
                onClick={(event: React.MouseEvent) => {
                  event.stopPropagation();
                  action.onClick();
                  close();
                }}
              />
            )}
          </DropdownItem>
        ))}
        {footer != null && (
          <>
            <div
              aria-hidden
              className="border-light-100 my-1 border-t"
            />
            <div className="px-2 py-0.5">
              {footer}
            </div>
          </>
        )}
      </DropdownItems>
    </Dropdown>
  );
};
